import { React, useContext, useEffect, useRef, useState } from "react";
import { PageContext } from "../../App";
import {
  renderPDFPages,
  readPDFFile,
  isPdfFilePasswordCorrect,
  formatBytes,
  isNumeric,
  readEncryptedPDFFileAsArrayBuffer,
  readPDFFileAsArrayBuffer,
  saveFile,
} from "../Utils";
import LoadingBar from "react-top-loading-bar";
import { PDFDocument } from "pdf-lib-plus-encrypt";
import { encryptPDF } from "../PDFHelper/PDFRenderer";

function DeletePDFPagesImagesListScreen(props) {
  // AppStatus.ts
  const AppState = {
    LOADED: "LOADED",
    PROCESSING: "PROCESSING",
    PROCESSED: "PROCESSED",
    NONE: "NONE",
  };

  //initialized flaf
  const initializedRef = useRef(false);
  //fileinfo list
  //store thumbnail, index etc key is filepath
  const [pdfInfo, setPdfInfo] = useState({
    state: AppState.NONE,
    pageCount: 0,
    selectedPages: { indices: [], message: "No pages selected." },
    pages: [], //pdf pages object {index, thumbnail}
    message: "",
    locked: false,
    password: "", //default no password
    name: "---",
    file: null, //selected file
    size: 0, //in bytes
    deleted_blob: null,
    deleted_size: 0,
  });
  //item displaying in password input modal
  const [selectedItemForPasswordInput, setSelectedItemForPasswordInput] =
    useState(null);
  //password input modal input field reference
  //get password value
  const passwordInputModalInputRef = useRef(null);
  //is deleting
  const [isDeleting, setIsDeleting] = useState(false);
  //loading bar progress
  const [progress, setProgress] = useState(0);

  //get context
  const {
    selectedFiles,
    setSelectedFiles,
    setShowEditFileScreen,
    setStartProcessingFiles,
  } = useContext(PageContext);

  //start
  useEffect(() => {
    //check
    if (initializedRef.current === false) {
      //set
      initializedRef.current = true;
      //selected file
      if (selectedFiles.length > 0) {
        //selected file
        const selectedFile = selectedFiles[0];
        //generate thumbnails
        processPDFFile(selectedFile, pdfInfo.password);
      }

      console.log("Load top loading bar");
    }

    //if selected files list is empty
    //reset screen
    //show upload button
    if (selectedFiles.length === 0) {
      //reset
      resetScreen();
    }

    //check
    //if locked and password not set
    if (pdfInfo.locked === true && pdfInfo.password === "") {
      //show password field
      setSelectedItemForPasswordInput(selectedFiles[0]);
      //click to focus modal
      document.getElementById("passwordModal").click();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFiles, pdfInfo]);

  //process pdf file
  const processPDFFile = (file, password) => {
    //generate thumbnails
    generateThumbnails(file, password);
  };

  //generate thumbnails
  const generateThumbnails = async (selectedFile, password) => {
    //check if file encrypted
    //check if given password is correct
    if ((await isPdfFilePasswordCorrect(selectedFile, password)) === true) {
      //read pdf file
      const data = await readPDFFile(selectedFile);

      //page images
      //extract pages as image
      const [images] = await renderPDFPages(
        data,
        password,
        "image/jpeg",
        0.5,
        false,
        false,
        [], //render all pages
        (perct, item, index) => {
          //add to pages
          setPdfInfo({
            ...pdfInfo,
            pages: [{ index: index, page_no: index + 1, thumbnail: item }],
            password: password,
            message: "",
            locked: false,
          });
          //set top loading bar progress
          setProgress(perct * 100);
        },
      );

      //set
      //values
      setPdfInfo({
        ...pdfInfo,
        state: AppState.LOADED,
        pageCount: images.length,
        selectedPages: {
          indices: [],
          message: "",
        }, //add all pages initially
        pages: images.map((item, index) => ({
          index: index,
          page_no: index + 1,
          thumbnail: item,
        })), //pdf pages object {page_no, thumbnail}
        message: "",
        locked: false,
        password: password,
        name: selectedFile.name,
        file: selectedFile, //selected file
        size: selectedFile.size, //in bytes
        deleted_blob: selectedFile,
        deleted_size: selectedFile.size,
      });
    } else {
      //set
      //values
      setPdfInfo({
        ...pdfInfo,
        state: AppState.NONE,
        pageCount: 0,
        selectedPages: {
          indices: [],
          message: "No Pages Selected",
        }, //add all pages initially
        pages: [], //pdf pages object {page_no, thumbnail}
        message: "PDF is locked.",
        locked: true,
        password: "",
        name: selectedFile.name,
        file: selectedFile, //selected file
        size: selectedFile.size, //in bytes
        deleted_blob: selectedFile,
        deleted_size: selectedFile.size,
      });
    }
  };

  //reset screen
  //remove files info
  //empty selected files list
  const resetScreen = () => {
    //set flags
    setSelectedFiles([]);
    setShowEditFileScreen(false);
    setPdfInfo({
      ...pdfInfo,
      state: AppState.NONE,
      pageCount: 0,
      selectedPages: { indices: [], message: "No pages selected." },
      pages: [], //pdf pages object {index, thumbnail}
      message: "",
      locked: false,
      password: "",
      name: "---",
      file: null, //selected file
      size: 0, //in bytes
      deleted_blob: null,
      deleted_size: 0,
    });
    setStartProcessingFiles(false);
  };

  //on  selectiontext value changed
  const onSelectiontextValueChanged = (e) => {
    //message
    var message = "";
    //page indices
    var pageIndices = [];
    //selectiontext
    const selectiontext = String(e.target.value);

    //split with ,
    const parts = selectiontext.split(",");
    //loop
    for (let i = 0; i < parts.length; i++) {
      //check for empty
      //string
      if (parts[i] === "") {
        //continue
        continue;
      }
      //check
      //break with -
      const rangeParts = parts[i].split("-");
      //check
      if (rangeParts.length === 1) {
        //check if number
        if (isNumeric(parts[i]) === true) {
          //set
          //-1 as index = pagenumber - 1
          pageIndices.push(
            Number(Math.min(pdfInfo.pageCount - 1, Math.max(0, parts[i] - 1))),
          );
        } else {
          //set message
          message = `${parts[i]} is not a valid number`;
        }
      } else if (rangeParts.length === 2) {
        //start
        var start = rangeParts[0];
        var end = rangeParts[1];
        //check
        if (isNumeric(start) === false || isNumeric(end) === false) {
          //message
          //set message
          message = `invalid declaration ${parts[i]}`;
        } else {
          //clamp start to range
          start = Math.min(rangeParts[0] - 1, rangeParts[1] - 1);
          start = Math.max(0, start);
          start = Math.min(start, pdfInfo.pageCount - 1);
          //clamp end to range
          end = Math.max(rangeParts[0] - 1, rangeParts[1] - 1);
          end = Math.max(0, end);
          end = Math.min(end, pdfInfo.pageCount - 1);

          //add indices
          for (var j = start; j <= end; j++) {
            //push
            //set
            pageIndices.push(Number(j));
          }
        }
      } else {
        //set message
        message = `Can't interpret ${parts[i]}`;
      }
    }

    //set selected pages
    setPdfInfo({
      ...pdfInfo,
      selectedPages: { indices: pageIndices, message: message },
    });
  };

  //render password input modal
  const renderPassordInputModal = (item) => {
    return (
      <div
        className="modal fade"
        id="passwordInputModal"
        tabIndex="-1"
        aria-labelledby="passwordInputModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="passwordInputModalLabel">
                {item !== null ? item.name : "Failed loading file"}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <form>
                <div className="mb-3">
                  <label htmlFor="password" className="col-form-label">
                    Unlock pdf to continue. Enter password below:
                  </label>
                  <input
                    type="password"
                    className="form-control mt-2"
                    id="password"
                    placeholder="Type password here..."
                    ref={passwordInputModalInputRef}
                  />
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                onClick={(e) => {
                  //process pdf
                  processPDFFile(item, "");
                  //clear reference value
                  passwordInputModalInputRef.current.value = null;
                }}
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary"
                data-bs-dismiss="modal"
                onClick={(e) => {
                  //process pdf file with password
                  processPDFFile(
                    item,
                    passwordInputModalInputRef.current.value,
                  );
                  //clear reference value
                  passwordInputModalInputRef.current.value = null;
                }}
              >
                Unlock
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  //render files list view
  const renderFilesListView = () =>
    //render
    pdfInfo.pages.map((item, index) => (
      <div
        className="mt-3"
        key={index}
        style={{ cursor: "pointer" }}
        onClick={(e) => {
          //toggle selection
          if (pdfInfo.selectedPages.indices.includes(item.index) === true) {
            //remove
            setPdfInfo({
              ...pdfInfo,
              selectedPages: {
                ...pdfInfo.selectedPages,
                indices: pdfInfo.selectedPages.indices.filter(
                  (indice) => indice !== item.index,
                ),
              },
            });
          } else {
            //add indices
            //remove
            setPdfInfo({
              ...pdfInfo,
              selectedPages: {
                ...pdfInfo.selectedPages,
                indices: [...pdfInfo.selectedPages.indices, item.index],
              },
            });
          }
        }}
      >
        {/* Flex container left image pdf right name and size */}
        <div className="position-relative d-flex bg-light border rounded-1 px-sm-3 px-2 py-4">
          {/* tick */}
          <div className="justify-content-center align-items-center text-center btn-group-vertical my-auto">
            <img
              loading="lazy"
              alt="tick"
              src={
                pdfInfo.selectedPages.indices.includes(item.index) === true
                  ? "./images/tick.svg"
                  : "./images/circle.svg"
              }
              style={{ width: "20px", height: "auto", maxWidth: "20px" }}
            />
          </div>
          {/* Left image */}
          <div className="ms-sm-3 ms-1 my-auto">
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ width: "80px", height: "80px" }}
            >
              {/* Image */}
              <img
                loading="lazy"
                src={
                  item.thumbnail !== null
                    ? URL.createObjectURL(item.thumbnail)
                    : "./images/file_icon.png"
                }
                alt="pdf_icon"
                style={{
                  width: "auto",
                  height: "auto",
                  maxWidth: "80px",
                  maxHeight: "80px",
                }}
              ></img>
            </div>
          </div>

          {/* Right name and size */}
          <div className="ms-3 my-auto d-none d-md-block d-sm-block me-5">
            <div className="px-2 fs-5 text-dark-subtle">
              Page No: {item.page_no}
            </div>
            {/* Size */}
            <div className="px-2 fs-6 text-body-secondary">
              {formatBytes(item.thumbnail === null ? 0 : item.thumbnail.size)}
            </div>
            <div className="d-flex mt-2">
              {/* file type */}
              <div
                className={`px-2 ms-2 my-auto rounded-2 fw-bold ${
                  pdfInfo.state === AppState.PROCESSED
                    ? "text-success"
                    : "bg-danger text-white"
                }`}
              >
                {pdfInfo.state === AppState.PROCESSED
                  ? "PROCESSED"
                  : "PDF Page"}
              </div>
            </div>
            {/* Warning */}
            <div
              className={`px-2 text-primary mt-3 text-lead ${
                pdfInfo.message !== "" ? "" : "d-none"
              }`}
              style={{ fontSize: "16px" }}
            >
              {pdfInfo.message}
            </div>
          </div>

          {/* Right side views spinners */}
          {/* Show spinner while processing */}
          {/* Spinner */}
          <div
            className="position-absolute  justify-content-center align-items-center text-center my-auto"
            style={{ right: "0px", top: "50%", transform: "translateY(-50%)" }}
          >
            <div
              className={`spinner-border my-auto me-2 ms-1 ${
                pdfInfo.state === AppState.PROCESSING ? "" : "d-none"
              }`}
              role="status"
            >
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      </div>
    ));

  return (
    //show hide loading view
    <div className="position-relative">
      {/* Loading Bar */}
      <LoadingBar progress={progress} onLoaderFinished={() => setProgress(0)} />

      {/* page main content */}
      <div>
        {/* Top bar */}
        <div className="bg-light border-bottom my-auto sticky-top">
          <div className="d-flex">
            <button
              type="button"
              className="btn btn-transparent"
              onClick={resetScreen}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="26"
                fill="#000000"
                className="bi bi-arrow-clockwise"
                viewBox="0 0 16 16"
              >
                <path
                  fillRule="evenodd"
                  d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"
                />
                <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466" />
              </svg>
            </button>
            {/* Title */}
            <label className="fs-3 ms-2 py-2 text-secondary fs-4">
              {props.title ?? "Delete Pdf Pages"}
            </label>
          </div>
        </div>

        {/*Container left list & right controls */}
        <div
          className="d-flex"
          style={{
            height: "calc(100vh - 52px)",
            maxHeight: "calc(100vh - 52px)",
          }}
        >
          {/* Left List */}
          <div
            className="mt-md-5 mt-sm-3 mt-1 ms-sm-5 ms-1 mb-3"
            style={{ width: "75%", maxWidth: "75%", overflowY: "auto" }}
            data-bs-toggle={`${pdfInfo.locked ? "modal" : ""}`}
            data-bs-target={`${pdfInfo.locked ? "#passwordInputModal" : ""}`}
            id="passwordModal"
          >
            {renderFilesListView()}
          </div>

          {/* Right controls */}
          <div
            className="ms-sm-5 ms-1  border-start position-relative"
            style={{
              marginBottom: "100px", //add space to bottom for button, else overlap
              width: "25%",
              maxWidth: "25%",
              overflowY: "auto",
              minWidth: "200px",
            }}
          >
            {/* Selection */}
            <div className="w-100 ms-4 mt-4 pt-3">
              {/* Title */}
              <label
                className="fs-3"
                title="Choose the pages you want to delete. Enter page numbers separated by commas (example: 1,2,3 etc), or select a range using a start page number and an end page number (example: [1-100])."
              >
                Selection:
              </label>
              {/* Selection text*/}
              <input
                type="text"
                className="form-control mt-4 me-4"
                id="selectionInput"
                aria-describedby="selecttext"
                placeholder="1,2,3,4-9 pages"
                onChange={onSelectiontextValueChanged}
                style={{ width: "calc(100% - 48px)" }}
              />
              {/* Message */}
              <label
                className={`fs-6 mt-3 text-danger ${
                  pdfInfo.selectedPages.message === ""
                    ? "d-none"
                    : pdfInfo.selectedPages.message
                }`}
                style={{
                  width: "calc(100% - 48px)",
                }}
              >
                {pdfInfo.selectedPages.message}
              </label>

              {/* Select Inverse Button */}
              <div className="mt-5">
                <button
                  className="btn btn-outline-primary"
                  onClick={(e) => {
                    //set
                    setPdfInfo({
                      ...pdfInfo,
                      selectedPages: {
                        ...pdfInfo.selectedPages,
                        indices: pdfInfo.pages
                          .filter(
                            (item) =>
                              !pdfInfo.selectedPages.indices.includes(
                                item.index,
                              ),
                          )
                          .map((item) => item.index),
                      },
                    });
                  }}
                >
                  Inverse Selection
                </button>
              </div>
            </div>

            {/* Details */}
            <div className="w-100 ms-4 mt-5 border-top pt-3">
              {/* Title */}
              <label className="fs-4">Details:</label>
              {/* Number of pages */}
              <div className="d-flex mt-2">
                {/* Label */}
                <label className="fs-6 text-secondary">
                  Pages:{" "}
                  {
                    pdfInfo.pages
                      .filter(
                        (item) =>
                          !pdfInfo.selectedPages.indices.includes(item.index),
                      )
                      .map((item) => item.index).length
                  }{" "}
                  pages
                </label>
              </div>
              {/* Total size */}
              <div className="d-flex mt-2">
                {/* Label */}
                <label className="fs-6 text-secondary">
                  Size:{" "}
                  {formatBytes(
                    pdfInfo.pageCount === 0
                      ? 0
                      : (pdfInfo.size / pdfInfo.pageCount) *
                          pdfInfo.pages
                            .filter(
                              (item) =>
                                !pdfInfo.selectedPages.indices.includes(
                                  item.index,
                                ),
                            )
                            .map((item) => item.index).length,
                  )}
                  *
                </label>
              </div>
            </div>

            {/* Convert Button */}
            <button
              className={`btn btn-danger py-2 py-sm-3 fs-4 position-fixed rounded-3 ${
                isDeleting ? "disabled" : ""
              }`}
              style={{
                marginLeft: "10px",
                width:
                  window !== undefined
                    ? window.innerWidth * 0.25 < 200
                      ? "180px"
                      : window.innerWidth * 0.25 - 40
                    : "180px",
                bottom: "10px",
                lineHeight: "1.1",
              }}
              type="button"
              onClick={async (e) => {
                //blur
                e.currentTarget.blur();
                //check
                //if indices not defined
                //return
                if (selectedFiles.length === 0) {
                  //return
                  return;
                }
                //set
                setIsDeleting(true);

                //set state
                setPdfInfo({
                  ...pdfInfo,
                  state: AppState.PROCESSING,
                  message: `Reading file...`,
                });

                //create new pdfdocument
                var convertedDoc = await PDFDocument.create();
                convertedDoc.setTitle("Deleted PDF");
                convertedDoc.setAuthor("shivapdf.com");
                convertedDoc.setSubject("Offline PDF Utilities");
                convertedDoc.setProducer("ShivaPDF");
                convertedDoc.setCreator("https://shivapdf.com");

                //try-catch
                try {
                  //read pdf file
                  let data = await readPDFFileAsArrayBuffer(selectedFiles[0]);

                  // Load a PDF with form fields
                  //if encrypted
                  //proceed to catch block
                  const pdfDoc = await PDFDocument.load(data);

                  //set state
                  setPdfInfo({
                    ...pdfInfo,
                    state: AppState.PROCESSING,
                    message: `Loading pages...`,
                  });

                  //copy pages
                  //pass inverse indices of selected pages
                  //as other pages needs to be kept
                  const copiedPages = await convertedDoc.copyPages(
                    pdfDoc,
                    pdfInfo.pages
                      .filter(
                        (item) =>
                          !pdfInfo.selectedPages.indices.includes(item.index),
                      )
                      .map((item) => item.index),
                  );

                  //indert to split pdf
                  for (let j = 0; j < copiedPages.length; j++) {
                    //page
                    const page = copiedPages[j];
                    //sdd page
                    //set state
                    setPdfInfo({
                      ...pdfInfo,
                      state: AppState.PROCESSING,
                      message: `Deleting selected pages...`,
                    });
                    //add page
                    convertedDoc.addPage(page);
                  }

                  //Save the new, merged document
                  const convertedPdfBytes = await convertedDoc.save();
                  // 1. Create a Blob from the byte data
                  // If your API returns a raw byte array, you can pass it directly: new Blob([pdfBytes], { type: 'application/pdf' })
                  // If it's a Base64 string, you might need a helper function to convert it to a Uint8Array first.
                  const blob = new Blob([convertedPdfBytes], {
                    type: "application/pdf",
                  });

                  //save
                  await saveFile(blob, pdfInfo.name + ".pdf");

                  //set
                  //set blob
                  setPdfInfo({
                    ...pdfInfo,
                    state: AppState.PROCESSED,
                    message: `Successfully deleted pages. New pdf file will be downloaded automatically on your device.`,
                    deleted_blob: blob,
                    deleted_size: blob.size,
                  });
                } catch (e) {
                  //render pdf pages
                  //at given indexes
                  //try catch
                  try {
                    //read pdf file
                    let data = await readEncryptedPDFFileAsArrayBuffer(
                      selectedFiles[0],
                      pdfInfo.password,
                      (perct) => {
                        //sdd page
                        //set state
                        setPdfInfo({
                          ...pdfInfo,
                          state: AppState.PROCESSING,
                          message: `Reading file ${Math.floor(
                            perct * 100,
                          )}%...`,
                        });
                      },
                    );

                    // Load a PDF with form fields
                    //if encrypted
                    //proceed to catch block
                    const pdfDoc = await PDFDocument.load(data);

                    //set state
                    setPdfInfo({
                      ...pdfInfo,
                      state: AppState.PROCESSING,
                      message: `Loading pages...`,
                    });

                    //copy pages
                    //pass inverse indices of selected pages
                    //as other pages needs to be kept
                    const copiedPages = await convertedDoc.copyPages(
                      pdfDoc,
                      pdfInfo.pages
                        .filter(
                          (item) =>
                            pdfInfo.selectedPages.indices.includes(
                              item.index,
                            ) === false,
                        )
                        .map((item) => item.index),
                    );

                    //indert to split pdf
                    for (let j = 0; j < copiedPages.length; j++) {
                      //page
                      const page = copiedPages[j];
                      //sdd page
                      //set state
                      setPdfInfo({
                        ...pdfInfo,
                        state: AppState.PROCESSING,
                        message: `Deleting selected pages...`,
                      });
                      //add page
                      convertedDoc.addPage(page);
                    }

                    //encrypt pdf
                    await encryptPDF(
                      "Deleted PDF",
                      convertedDoc,
                      pdfInfo.password,
                      { printable: true, cancopy: true },
                      async (blob) => {
                        //save
                        await saveFile(blob, pdfInfo.name + ".pdf");

                        //set
                        //set blob
                        setPdfInfo({
                          ...pdfInfo,
                          state: AppState.PROCESSED,
                          message: `Successfully deleted pages. New pdf file will be downloaded automatically on your device.`,
                          deleted_blob: blob,
                          deleted_size: blob.size,
                        });
                      },
                    );
                  } catch (e) {}
                }

                //reset
                setIsDeleting(false);
              }}
            >
              Delete Pages <br />
              <span className="fs-6">Remove selected pages from pdf</span>
            </button>
          </div>
        </div>
      </div>

      {/* Password input modal */}
      {renderPassordInputModal(selectedItemForPasswordInput)}
    </div>
  );
}

export default DeletePDFPagesImagesListScreen;
